import React from "react";
import PropTypes from "prop-types";

export class ErrorBoundary extends React.Component {
  constructor(props){ super(props); this.state = { error: null, info: null }; }
  static getDerivedStateFromError(error){ return { error }; }
  componentDidCatch(error, info){
    // eslint-disable-next-line no-console
    console.error("ErrorBoundary caught:", error, info);
    this.setState({ info });
  }
  render(){
    if (this.state.error){
      return (
        <div className="min-h-screen bg-gray-950 text-gray-100 flex items-center justify-center p-6">
          <div className="max-w-xl w-full border border-rose-700/40 bg-rose-900/20 rounded-2xl p-6 shadow-lg space-y-3">
            <div className="flex items-center gap-2 text-rose-200">
              <span className="inline-flex h-3 w-3 rounded-full bg-rose-400 animate-pulse" aria-hidden />
              <p className="text-sm font-semibold uppercase tracking-wide">Dashboard crash recovered</p>
            </div>
            <div className="space-y-1">
              <h1 className="text-xl font-semibold text-white">Something went wrong</h1>
              <p className="text-sm text-gray-200">
                The dashboard encountered an unexpected error. Please refresh the page. The error has been logged to the console for investigation.
              </p>
            </div>
            <details className="text-xs text-gray-200 bg-gray-900/60 border border-gray-800 rounded-lg p-3 leading-relaxed">
              <summary className="cursor-pointer text-gray-300">Error details</summary>
              <pre className="whitespace-pre-wrap mt-2 text-[11px] leading-snug text-gray-100">
                {String(this.state.error?.stack || this.state.error)}
                {"\n"}{this.state.info?.componentStack || ""}
              </pre>
            </details>
            <button
              type="button"
              className="px-4 py-2 text-sm font-semibold rounded-md bg-purple-700 text-white hover:bg-purple-600"
              onClick={() => window.location.reload()}
            >
              Refresh dashboard
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

ErrorBoundary.propTypes = {
  children: PropTypes.node.isRequired,
};

export default ErrorBoundary;
